(function($) {
  'use strict';

  var AjaxQty = {
    init: function() {
      this.qtyUpdateHandler();
      this.qtyInputHandler();
      this.globalAjaxListener();
    },

    globalAjaxListener: function() {
      var self = this;
      $(document).ajaxSuccess(function(event, xhr, settings) {
        if (settings.url.indexOf('/cart/add.js') !== -1 || settings.url.indexOf('/cart/change.js') !== -1 || settings.url.indexOf('/cart/update.js') !== -1) {
          self.syncAll();
        }
      });
    },

    syncAll: function() {
      var self = this;
      
      // 1. Fetch current cart JSON for slider UI and header count
      $.getJSON('/cart.js', function(cart) {
        // Update header cart counts
        $('.CartCount, #CartCountCavas').text(cart.item_count);
        
        // Update slider/grid UI
        $('.product-item-qty-ajax-container').each(function() {
          var $container = $(this);
          var $form = $container.find('form');
          var $qtyBox = $container.find('.product-item-qty-ajax');
          var $input = $qtyBox.find('.qty-ajax-input');
          var variantId = $container.find('[name="id"]').val();
          
          var cartItem = null;
          if (cart.items && variantId) {
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].id == variantId || cart.items[i].variant_id == variantId) {
                cartItem = cart.items[i];
                break;
              }
            }
          }

          if (cartItem) {
            $form.addClass('hide');
            $qtyBox.removeClass('hide');
            $input.val(cartItem.quantity);
          } else {
            $qtyBox.addClass('hide');
            $form.removeClass('hide');
            $input.val(1);
          }
        });
      });

      // 2. Refresh mini-cart sidebar content
      // The theme uses /cart?view=json to get the mini-cart HTML
      $.get('/cart?view=json', function(html) {
        $('#cart-info').html(html);
        
        // Trigger theme's self-update for counts and other logic
        if (window.nuranium && typeof window.nuranium.updateMiniCart === 'function') {
          window.nuranium.updateMiniCart();
        }
      });
    },

    qtyUpdateHandler: function() {
      var self = this;
      $(document).on('click', '.qty-ajax-btn', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $btn = $(this);
        var $container = $btn.closest('.product-item-qty-ajax-container');
        var variantId = $container.find('[name="id"]').val();
        var $input = $container.find('.qty-ajax-input');
        var currentQty = parseInt($input.val()) || 0;
        var newQty = $btn.hasClass('qty-ajax-plus') ? currentQty + 1 : currentQty - 1;

        if (newQty < 0) newQty = 0;
        if (!variantId) return;

        $container.css('opacity', '0.5').css('pointer-events', 'none');
        if (newQty > 0) $input.val(newQty);

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + newQty + '&id=' + variantId,
          dataType: 'json',
          complete: function() {
            $container.css('opacity', '1').css('pointer-events', 'auto');
          }
        });
      });
    },

    qtyInputHandler: function() {
      var self = this;
      $(document).on('change', '.qty-ajax-input', function() {
        var $input = $(this);
        var $container = $input.closest('.product-item-qty-ajax-container');
        var variantId = $container.find('[name="id"]').val();
        var newQty = parseInt($input.val());

        if (isNaN(newQty) || newQty < 0) newQty = 1;

        $container.css('opacity', '0.5').css('pointer-events', 'none');
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + newQty + '&id=' + variantId,
          dataType: 'json',
          complete: function() {
            $container.css('opacity', '1').css('pointer-events', 'auto');
          }
        });
      });
    }
  };

  $(document).ready(function() {
    AjaxQty.init();
    AjaxQty.syncAll();
  });

})(jQuery);
